import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Mail, MapPin, AlertCircle } from 'lucide-react';
export function RefundPolicyPage() {
  return <div className="min-h-screen bg-white" data-id="element-1227">
      {/* Header */}
      <Header variant="dark" data-id="element-1228" />

      {/* Hero Section */}
      <section className="bg-neutral-100 py-32 px-8 mt-32" data-id="element-1229">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1230">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1231" />
          <h1 className="font-heading text-5xl lg:text-6xl text-neutral-900 mb-6 leading-tight" data-id="element-1232">
            Refund Policy
          </h1>
          <p className="text-lg text-neutral-600 leading-relaxed" data-id="element-1233">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-AU', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-white py-20 px-8" data-id="element-1234">
        <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1235">
          {/* Returns */}
          <div className="mb-12" data-id="element-1236">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1237" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1238">
              Returns
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1239">
              Our policy lasts 30 days. If 30 days have gone by since your
              purchase, unfortunately we can't offer you a refund or exchange.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1240">
              To be eligible for a return, your item must be unused and in the
              same condition that you received it. It must also be in the
              original packaging.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1241">
              Perishable goods such as food, and gift cards are exempt from
              being returned.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1242">
              To complete your return, we require a receipt or proof of
              purchase.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1243">
              <strong data-id="element-1244">
                There are certain situations where only partial refunds are
                granted (if applicable):
              </strong>
            </p>
            <ul className="list-disc pl-6 space-y-2 text-neutral-600 mb-6" data-id="element-1245">
              <li data-id="element-1246">
                Any item not in its original condition, is damaged or missing
                parts for reasons not due to our error
              </li>
              <li data-id="element-1247">
                Any item that is returned more than 30 days after delivery
              </li>
            </ul>
          </div>

          {/* Refunds */}
          <div className="mb-12" data-id="element-1248">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1249" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1250">
              Refunds (if applicable)
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1251">
              Once your return is received and inspected, we will send you an
              email to notify you that we have received your returned item. We
              will also notify you of the approval or rejection of your refund.
            </p>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1252">
              If you are approved, then your refund will be processed, and a
              credit will automatically be applied to your credit card or
              original method of payment, within a certain amount of days.
            </p>
          </div>

          {/* Late or Missing Refunds */}
          <div className="mb-12" data-id="element-1253">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1254" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1255">
              Late or Missing Refunds (if applicable)
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1256">
              If you haven't received a refund yet, first check your bank
              account again.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1257">
              Then contact your credit card company, it may take some time
              before your refund is officially posted.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1258">
              Next contact your bank. There is often some processing time before
              a refund is posted.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-1259">
              If you've done all of this and you still have not received your
              refund yet, please contact us at{' '}
              <a href="mailto:bubbles@petersonhouse.com.au" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1260">
                bubbles@petersonhouse.com.au
              </a>
              .
            </p>
          </div>

          {/* Sale Items */}
          <div className="mb-12" data-id="element-1261">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1262" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1263">
              Sale Items (if applicable)
            </h2>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1264">
              Only regular priced items may be refunded, unfortunately sale
              items cannot be refunded.
            </p>
          </div>

          {/* Exchanges */}
          <div className="mb-12" data-id="element-1265">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1266" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1267">
              Exchanges (if applicable)
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-1268">
              We only replace items if they are defective or damaged. If you
              need to exchange it for the same item, send us an email at{' '}
              <a href="mailto:bubbles@petersonhouse.com.au" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1269">
                bubbles@petersonhouse.com.au
              </a>{' '}
              and send your item to:
            </p>

            <div className="bg-neutral-50 border border-neutral-200 p-6 rounded-none mb-6" data-id="element-1270">
              <div className="flex items-start gap-3" data-id="element-1271">
                <MapPin className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1272" />
                <div data-id="element-1273">
                  <p className="text-neutral-900 font-medium mb-1" data-id="element-1274">
                    Return Address
                  </p>
                  <p className="text-neutral-600 leading-relaxed" data-id="element-1275">
                    Peterson House Ltd
                    <br data-id="element-1276" />
                    2457 Broke Road, Pokolbin NSW 2320
                    <br data-id="element-1277" />
                    Australia
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Gifts */}
          <div className="mb-12" data-id="element-1278">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1279" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1280">
              Gifts
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1281">
              If the item was marked as a gift when purchased and shipped
              directly to you, you'll receive a gift credit for the value of
              your return. Once the returned item is received, a gift
              certificate will be mailed to you.
            </p>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1282">
              If the item wasn't marked as a gift when purchased, or the gift
              giver had the order shipped to themselves to give to you later, we
              will send a refund to the gift giver and they will find out about
              your return.
            </p>
          </div>

          {/* Shipping */}
          <div className="mb-12" data-id="element-1283">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1284" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1285">
              Shipping
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-1286">
              To return your product, you should mail your product to:
            </p>

            <div className="bg-neutral-50 border border-neutral-200 p-6 rounded-none mb-6" data-id="element-1287">
              <div className="flex items-start gap-3" data-id="element-1288">
                <MapPin className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1289" />
                <div data-id="element-1290">
                  <p className="text-neutral-900 font-medium mb-1" data-id="element-1291">
                    Return Address
                  </p>
                  <p className="text-neutral-600 leading-relaxed" data-id="element-1292">
                    Peterson House Ltd
                    <br data-id="element-1293" />
                    2457 Broke Road, Pokolbin NSW 2320
                    <br data-id="element-1294" />
                    Australia
                  </p>
                </div>
              </div>
            </div>

            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1295">
              You will be responsible for paying for your own shipping costs for
              returning your item. Shipping costs are non-refundable. If you
              receive a refund, the cost of return shipping will be deducted
              from your refund.
            </p>
            <p className="text-neutral-600 leading-relaxed mb-4" data-id="element-1296">
              Depending on where you live, the time it may take for your
              exchanged product to reach you, may vary.
            </p>
            <p className="text-neutral-600 leading-relaxed" data-id="element-1297">
              If you are shipping an item over $75, you should consider using a
              trackable shipping service or purchasing shipping insurance. We
              don't guarantee that we will receive your returned item.
            </p>
          </div>

          {/* Contact Section */}
          <div className="mb-12" data-id="element-1298">
            <div className="w-12 h-0.5 bg-brand-pink mb-4" data-id="element-1299" />
            <h2 className="font-heading text-3xl text-neutral-900 mb-6" data-id="element-1300">
              Questions?
            </h2>
            <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-1301">
              If you have any questions about our refund policy, please don't
              hesitate to contact us:
            </p>

            <div className="bg-neutral-50 border border-neutral-200 p-6 rounded-none" data-id="element-1302">
              <div className="flex items-start gap-3" data-id="element-1303">
                <Mail className="w-5 h-5 text-brand-pink mt-1 flex-shrink-0" data-id="element-1304" />
                <div data-id="element-1305">
                  <p className="text-neutral-900 font-medium mb-1" data-id="element-1306">Email</p>
                  <a href="mailto:bubbles@petersonhouse.com.au" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1307">
                    bubbles@petersonhouse.com.au
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1308" />
    </div>;
}